import styled from "styled-components";

export const SuggestionListWrapperMobile = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: ${({ theme }) => theme.spacing(1.5)};
  box-shadow: ${({ theme }) => theme.shadows.light.medium};
  height: 100vh;
`;

export const SectionTitleMobile = styled.div`
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  padding-left: ${({ theme }) => theme.spacing(1)};
  font-size: ${({ theme }) => theme.fontSizes.md};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;

export const SectionRegionalTitleMobile = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: ${({ theme }) => theme.colors.vividBlue};
  padding-left: ${({ theme }) => theme.spacing(1)};
  gap: ${({ theme }) => theme.spacing(0.5)};
  font-size: ${({ theme }) => theme.fontSizes.md};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin-bottom: ${({ theme }) => theme.spacing(0.5)};

  svg {
    color: ${({ theme }) => theme.colors.vividBlue};
    align-self: center;
  }
`;

export const ColumnMobile = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const ColumnTitleMobile = styled.div`
  color: ${({ theme }) => theme.colors.darkGray};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin-top: ${({ theme }) => theme.spacing(0.1)};
`;

export const ListWrapperMobile = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};
`;

export const FixedListMobile = styled.div`
  gap: ${({ theme }) => theme.spacing(0.5)};
  grid-template-columns: 1fr;
  display: grid;
`;

export const ScrollableListMobile = styled.div`
  border-top: 2px solid ${({ theme }) => theme.colors.lightGray};
  max-height: calc(100vh - ${({ theme }) => theme.spacing(53)});
  gap: ${({ theme }) => theme.spacing(0.5)};
  flex-direction: column;
  overflow-y: scroll;
  display: flex;

  scrollbar-color: ${({ theme }) => theme.colors.vividBlue}
    ${({ theme }) => theme.colors.lightGray};
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: ${({ theme }) => theme.spacing(1)};
    background: ${({ theme }) => theme.colors.lightGray};
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.vividBlue};
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }
`;
